<template>
  <span>
    <a
      class="nav-link dropdown-toggle"
      v-on-clickaway="hideDropdown"
      :class="{ active: isTabActive }"
      @click="toggleDropdown"
      >{{ $t(tab.title) }}
    </a>

    <div class="dropdown-menu" :class="{ show: expanded }">
      <check-permission
        v-for="(dropdownItem, index) in tab.children"
        :key="index"
        :entityId="entityId"
        :entityType="entityType"
        :permissions="dropdownItem.permissions"
      >
        <tab-link class="dropdown-item" :tab="dropdownItem" />
      </check-permission>
    </div>
  </span>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

import TabLink from './TabLink';

// @vuese
// Dropdown zakładki
// @group Components
export default {
  mixins: [clickaway],
  components: { TabLink },
  props: {
    // Zakładka z menu
    tab: {
      type: Object,
      required: true
    },
    // Encja
    entityType: {
      type: String,
      required: false
    },
    // Id encji
    entityId: {
      type: String,
      required: false
    }
  },
  data() {
    return { expanded: false };
  },
  methods: {
    // @vuese
    // Rozsuwa menu
    toggleDropdown() {
      this.expanded = !this.expanded;
    },
    // @vuese
    // Chowa menu
    hideDropdown() {
      this.expanded = false;
    },
    // @vuese
    // Ustawia elment menu jako aktywny
    isDropdownItemActive(tab) {
      return tab && tab.route && this.$route.name === tab.route.name;
    }
  },
  computed: {
    isTabActive() {
      return this.tab.children.some(childrenTab => this.isDropdownItemActive(childrenTab));
    }
  }
};
</script>

<style>
.dropdown-toggle {
  cursor: pointer;
}
</style>
